module.exports = __webpack_public_path__ + "img/GP3.Croatia_GREENPACT_Logo_Standard_large.c55a3288.png";